import { mapState } from 'vuex';
var PhoneValidator = require('rf-phone-validator');
var EmailValidator = require("email-validator");

export default {
    name: 'Registration',


    data : function(){


        return {
            login : '',
            password : '',
            confirmpassword : '',
            inviteCode: null,
        }

    },

    computed: mapState({
        auth : state => state.auth,
        cansignup : function(){
            if(this.login && this.password && this.confirmpassword == this.password){
                return true
            }
        },
        phoneEnabled : function(){
            return process.env.VUE_APP_PHONE_ENABLED == 1;
        }
    }),

    methods : {
        errorHandler : function(e){


            var code = this.$f.deep(e, 'error.code')

            if (code == 'ER_DUP_ENTRY'){

                this.$store.commit('icon', {
                    icon : 'error',
                    message : this.$t('message.emailusing') 
                })

                return
            }

            this.$message({
                title : this.$t('message.someerrors'),
                message : JSON.stringify(e)
            })
        },
        signup : function(){
            var pv = new PhoneValidator(this.login);

            var t = this;

            if (this.confirmpassword != this.password){

                this.$store.commit('icon', {
                    icon : 'error',
                    message : this.$t('message.passwordsdmatch') 
                })

                return
            }

            if(this.password && (EmailValidator.validate(this.login) || pv.valid())){

                var result = this.$root.user.signup({

                    login : this.login,
                    password : this.password,


                    data : {
                        language : this.$f.language(),
                        inviteCode: this.$store.state.inviteCode
                    }

                }).then(state => {

                    // t.$store.commit('lastlogin', t.login)
                    t.$router.push('/getApp/');
                    localStorage['registered'] = true;

                    t.$store.commit('icon', {
                        icon : 'success',
                        message : this.$t('message.accountcreated') 
                    })

                }).catch(e => {
                    this.$store.commit('icon', {
                        icon : 'error',
                        message : this.$t('message.unknownError')
                    })
                    t.errorHandler(e)

                });
            }

            else{

                t.$message({
                    title : this.$t('message.loginmustvalidemail'),
                    message : ''
                })

            }


        },

        back : function(){
            this.$router.go(-1)
        },

        

        acceptNumber : function(e){

            this.login = e.target.value; 

            if(!this.login) return

            var isEmail = this.login.replace(/[a-zA-Z@]+/g, '').length != this.login.length


            if (isEmail || !this.phoneEnabled){

            }
            else{
                var x = this.login.replace(/\D/g, '').match(/(\d{1})(\d{0,3})(\d{0,3})(\d{0,4})/);

                this.login = !x[2] ? x[1] : '+' + x[1] + ' (' + x[2] + ') ' + x[3] + (x[4] ? '-' + x[4] : '');
            }
            

        }
    },

}